<template>
  <div class="r-icon" align="center">
    <div class="r-icon--wrap">
      <img :src="require(`@/assets/icons/${icon}.svg`)" v-if="isSpecialIcon" />
      <i :class="classList" v-else></i>
    </div>
  </div>
</template>

<script>
/**
 * Define the RIcon component
 */
export default {
  // set component name
  name: "r-icon",

  // external properties
  props: {
    // icon name
    icon: {
      type: String,
      required: true
    },

    // the icon color
    color: {
      type: String,
      default: "grey/purple"
    },

    // small icon
    small: {
      type: Boolean,
      default: false
    },

    // large icon
    large: {
      type: Boolean,
      default: false
    }
  },

  // calculated props
  computed: {
    /**
     * Understand if should point to special icons
     */
    isSpecialIcon() {
      return [
        "outlook",
        "whatsapp",
        "telegram",
        "gmail",
        "line",
        "hubspot",
        "salesforce"
      ].includes(this.icon)
    },

    /**
     * Calculated class list
     */
    classList() {
      const props = [
        "uil",
        `uil-${this.icon}`,
        this.small ? "r-icon--small" : undefined,
        this.large ? "r-icon--large" : undefined,
        this.color === "primary" ? "r-icon--primary" : undefined,
        this.color === "secondary" ? "r-icon--secondary" : undefined,
        this.color === "black" ? "r-icon--black" : undefined,
        this.color === "white" ? "r-icon--white" : undefined
      ]

      return props.join(" ")
    }
  }
}
</script>

<style lang="scss">
@import "../../../style/_main.scss";

.r-icon {
  font-size: 28px;
  color: map-deep-get($rele-light-colors, "grey", "purple");
  margin-bottom: 10px;

  &--wrap {
    img {
      width: 16px;
    }
  }

  &--small {
    font-size: 20px;
  }

  &--large {
    font-size: 15vh;
  }

  &--primary {
    color: map-deep-get($rele-light-colors, "primary");
  }

  &--secondary {
    color: map-deep-get($rele-light-colors, "secondary");
  }

  &--black {
    color: black;
  }

  &--white {
    color: white;
  }
}

.router-link-exact-active {
  .r-icon--wrap {
    background-color: map-deep-get($rele-light-colors, "primary");
    border-radius: 50%;
    width: 40px;
    color: white;
  }
}
</style>
